module.exports = __webpack_public_path__ + "img/sq6m_03.6537f6b6.jpg";